import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/error")({
  component: ErrorLayout,
});

/**
 * Error layout provides a clean, centered container for error screens.
 *
 * This layout is intentionally minimal - no header, no sidebars, just a
 * centered container for error-related content. This prevents confusion
 * with the main app UI when users encounter critical errors (like no
 * organization access).
 */
function ErrorLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Outlet />
    </div>
  );
}
